var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"s-btn",class:{'grey': !_vm.canUse, 'blue': _vm.blue},on:{"click":_vm.confirm}},[_vm._v("\n  "+_vm._s(_vm.text)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }